import { render, staticRenderFns } from "./ModalPages.vue?vue&type=template&id=619d1a12&"
import script from "./ModalPages.vue?vue&type=script&lang=js&"
export * from "./ModalPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports